const IntroContent = {
	role: [
		"Leading UX/UI",
		"Research",
		"Wireframing",
		"Prototyping",
		"Front-end build",
		"Responsive design",
		"Collaboration",
	],
	meta: "Overview",
	title: "Assessing the existing solution",
	paras: [
		"The problems with the product search were the first I addressed when I joined this new front-end team at Iglu.com. The team's remit was to primarily boost online sales while also increasing enquiries to the sales call centre.",
		"On the existing site, this is where the highest volume of visitors arrived. They would mostly arrive from an open search on Google or Bing where they would see a paid link matching their search queries. The routing would bring them to a dynamic landing page template, reflecting the original search terms.",
		'A typical search would look like " cruise mediterannean july family best price ".',
		"There was a high drop-off rate at this search template, making paid search very costly and inefficient for the company. From an initial 'UX audit' I could make a long list of assumptions as to user pain-points. I also did an extensive review of competitors and leading Online Travel Agency sites to get a sense of 'benchmark'.",
	],
	img01alt: "The existing design, desktop view",
	img02alt: "The existing design, mobile view",
	captions: [
		"Overall the existing template looked very dated, like it had not been advanced in 10 years. It was well below any benchmark with competitors",
		"The site was a set width of 960px and did not display well at tablet ranges",
		"The search form was very cumbersome to use. Any parameter changes would have to be manually re-submitted. The refresh of results was slow and felt punishing.",
		"Key information was missing from this card design, as well as the presentation being less than professional",
		"Information not required by the user at this stage was dominating the views. The low standard of display created a lack of trust.",
		"Information crucial to help users differentiate and decide was removed on mobile views.",
	],
	quote: {
		statement:
			"The site looks clunky and a bit cheap... bit unfinished, like a comparison site or cheap car insurance.",
		personna: "Andrew, 46 - 'One-time cruiser'",
	},
};

export default IntroContent;
